import React, { useEffect, useState } from 'react';
import { authFetch, getToken } from '../auth';

const CabinetsModal = ({ open, API_URL, onClose, onSelect, switchingName = '' }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [items, setItems] = useState([]);
  const switching = !!String(switchingName || '').trim();
  const busy = loading || switching;

  useEffect(() => {
    if (!open) return;
    (async () => {
      setError('');
      setLoading(true);
      try {
        const res = await authFetch(`${API_URL}/cabinets`);
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || 'Failed to load cabinets');
        const rows = await res.json();
        setItems(Array.isArray(rows) ? rows : []);
      } catch (e) {
        setError(e.message || 'Failed to load cabinets');
      } finally {
        setLoading(false);
      }
    })();
  }, [open, API_URL]);

  if (!open) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={header}>
          <h3 style={title}>Select Cabinet</h3>
          <button className="btn btn-clear" onClick={onClose} disabled={busy}>Close</button>
        </div>
        {error && <div style={errorText}>{error}</div>}
        <div style={body}>
          {switching ? (
            <div style={loadingRow}>
              <div style={spinner}></div>
              <div>Switching to {switchingName}…</div>
            </div>
          ) : loading ? (
            <div style={loadingRow}>
              <div style={spinner}></div>
              <div>Loading cabinets…</div>
            </div>
          ) : (
            <div style={grid}>
              {items.map(item => (
                <button
                  key={item.id}
                  onClick={() => onSelect && onSelect(item)}
                  className="btn-ghost"
                  disabled={busy}
                  style={card}
                >
                  <div style={cardInner}>
                    <div style={logoBox}>
                      {item.has_logo ? (
                        <img
                          alt={item.name}
                          src={`${API_URL}/cabinets/${item.id}/logo?token=${encodeURIComponent(getToken()||'')}`}
                          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                      ) : (
                        <div style={{ fontSize: 22 }}>🗄️</div>
                      )}
                    </div>
                    <div style={cardTitle}>{item.name}</div>
                  </div>
                </button>
              ))}
              {(!items || items.length === 0) && (
                <div style={emptyText}>No cabinets found.</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1001, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 };
const modal = { width: 620, maxWidth: '95vw', background: 'var(--modal-bg)', color: 'var(--text)', borderRadius: 10, padding: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', gap: 8 };
const header = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 };
const title = { margin: 0 };
const body = { marginTop: 4 };
const errorText = { color: 'var(--danger)', marginTop: 8 };
const loadingRow = { display: 'flex', alignItems: 'center', gap: 10 };
const grid = { display: 'grid', gridTemplateColumns: '1fr', gap: 10, justifyItems: 'stretch', alignItems: 'start' };
const card = { width: '100%', textAlign: 'left', padding: 12, border: '1px solid var(--border)', borderRadius: 8, background: 'var(--card-bg)', display: 'block' };
const cardInner = { display: 'grid', gridTemplateColumns: '44px minmax(0, 1fr)', alignItems: 'center', gap: 12, width: '100%' };
const cardTitle = { textAlign: 'left', fontWeight: 600, minWidth: 0 };
const emptyText = { color: 'var(--text-soft)' };
const logoBox = { width: 44, height: 44, borderRadius: 6, background: 'var(--hover-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' };
const spinner = { border: '6px solid #e0e0e0', borderTop: '6px solid #1565c0', borderRadius: '50%', width: 36, height: 36, animation: 'spin 1s linear infinite' };
// verticalName no longer used

export default CabinetsModal;
